export const isControlPoint = (point) => 'id' in point;